var spriteIcons_default = [
  "arrow-right",
  "arrow-left",
  "arrow-right-long",
  "cart-shopping",
  "chevron-right",
  "download",
  "error",
  "error-image",
  "empty-cart",
  "heart",
  "heart-circle-check",
  "no-results",
  "plus",
  "xmark",
  "burger",
  "search",
  "account",
  "arr-left",
  "arr-right",
  "parts-traktor",
  "parts-tresker",
  "parts-redskap",
  "parts-sm-maskiner",
  "parts-deler",
  "parts-tilbehor",
  "parts-anlegg",
  "parts-marine",
  "sort",
  "chev-down",
  "filter",
  "phone",
  "trash",
  "grid",
  "list",
  "traktor"
];
export { spriteIcons_default as default };
